import { useMemo } from 'react';
import { Skeleton, Box } from '@mui/material';
import { ApolloError } from '@apollo/client';

import { Typography } from '@occc-app/design-system';
import { TimeSeriesDataPoint } from '@occc/graphql';
import { parseDate } from '@occc-app/lib/date';
import { MetricBarChart, MetricType } from '@occc/ui-design-system';

import { CHART_HEIGHT } from '../scan-data-overview.constants';

export type ScanDataMetricBarChartProps = {
  loading: boolean;
  error: ApolloError | undefined;
  data: TimeSeriesDataPoint[] | undefined;
  metricsType?: MetricType;
  centsThreshold?: number;
};

export const ScanDataMetricBarChart = ({
  loading,
  error,
  data,
  metricsType,
  centsThreshold,
}: ScanDataMetricBarChartProps) => {
  const metrics = useMemo(() => {
    return data?.map(({ date, value }) => ({ date: parseDate(date), value }));
  }, [data]);

  if (loading && !metrics) {
    return <Skeleton variant='rectangular' width='100%' height={CHART_HEIGHT} />;
  }

  if (error || !metrics) {
    return (
      <Box p={4} height={CHART_HEIGHT}>
        <Typography color='error'>Something went wrong. Please try again.</Typography>
      </Box>
    );
  }

  return (
    <MetricBarChart
      height={CHART_HEIGHT}
      metrics={metrics}
      metricsType={metricsType}
      centsThreshold={centsThreshold}
    />
  );
};
